import createTableStore from "ds/components/Table/store/useTableStore";

import { SCAN_RESOURCES_COLUMN_CONFIG, SCAN_RESOURCES_COLUMNS_STORAGE_KEY } from "./constants";

const useScanResourcesTableStore = createTableStore({
  storageKey: SCAN_RESOURCES_COLUMNS_STORAGE_KEY,
  config: SCAN_RESOURCES_COLUMN_CONFIG,
  version: 4,
});

export default useScanResourcesTableStore;
